// extracted by mini-css-extract-plugin
export default {"root":"fKjcV12qHU","title":"S0N11e0Nug","text":"_VTMsvMU6g"};